export default "__VITE_ASSET__5sNI3mwp__"